import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Captcha, ValidCaptcha } from '../../Functions/Capcha.function';
import URL from '../../Config';
import './ModalRecuperarPassword.css';

const ModalRecuperarPassword = ({ isOpen, onClose, tipo = 'SICAI' }) => {
  const [correo, setCorreo] = useState('');
  const [captcha, setCaptcha] = useState('');
  const [humano, setHumano] = useState('');
  const [loading, setLoading] = useState(false);

  const displayTipo = tipo === 'SICAI' ? 'SICAI' : 'DeConnect';

  useEffect(() => {
    if (isOpen) {
      setCaptcha(Captcha());
      setCorreo('');
      setHumano('');
      setLoading(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleNuevoCaptcha = () => {
    setCaptcha(Captcha());
    setHumano('');
  };

  const handleEnviar = async (e) => {
    e.preventDefault();

    if (!correo.trim()) {
      Swal.fire({
        title: 'Atención',
        text: 'Es necesario escribir el correo con el cual se registró',
        icon: 'warning',
        confirmButtonColor: '#C8102E'
      });
      return;
    }

    if (!ValidCaptcha(captcha, humano)) {
      Swal.fire({
        title: 'Atención',
        text: 'El código captcha no es correcto',
        icon: 'warning',
        confirmButtonColor: '#C8102E'
      });
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(URL.EnvioRecuracion, {
        tipo: displayTipo === 'SICAI' ? '1' : '2',
        correo: correo.trim()
      });

      if (response.status === 200) {
        Swal.fire({
          title: 'Exitoso',
          text: typeof response.data === 'string' ? response.data : 'Se han enviado las instrucciones de recuperación a tu correo.',
          icon: 'success',
          confirmButtonColor: '#C8102E'
        });
        setCorreo('');
        setHumano('');
        setCaptcha(Captcha());
        onClose();
      } else {
        Swal.fire({
          title: 'Atención',
          text: response.data?.Message || response.data || 'No fue posible completar la solicitud.',
          icon: 'warning',
          confirmButtonColor: '#C8102E'
        });
      }
    } catch (err) {
      if (err.response && err.response.status === 400) {
        Swal.fire({
          title: 'Atención',
          text: err.response.data?.Message || 'El correo ingresado no se encuentra registrado.',
          icon: 'warning',
          confirmButtonColor: '#C8102E'
        });
      } else {
        Swal.fire({
          title: 'Error',
          text: 'Ocurrió un error en el servidor. Por favor intenta de nuevo más tarde.',
          icon: 'error',
          confirmButtonColor: '#C8102E'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="df-recuperar-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="recuperar-titulo">
      <div className="df-recuperar-modal-backdrop" onClick={onClose} aria-hidden="true" />

      <div className="df-recuperar-modal-dialog">
        {/* Cabecera Oficial */}
        <div className="df-recuperar-modal-header">
          <div className="df-recuperar-modal-header-titles">
            <span className="df-recuperar-modal-tag">RECUPERACIÓN DE CONTRASEÑA</span>
            <h2 id="recuperar-titulo" className="df-recuperar-modal-title">
              Instalación {displayTipo}
            </h2>
          </div>

          <button
            type="button"
            className="df-recuperar-modal-close-btn"
            onClick={onClose}
            aria-label="Cerrar modal"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>

        {/* Cuerpo del Formulario */}
        <form onSubmit={handleEnviar} className="df-recuperar-modal-form">
          <div className="df-recuperar-modal-body">
            <p className="df-recuperar-info-text">
              Ingresa el correo electrónico con el que te registraste. Te enviaremos un enlace seguro para restablecer la contraseña de tu instalación.
            </p>

            <div className="df-recuperar-field-group">
              <label htmlFor="recuperar-email" className="df-recuperar-label">
                Correo electrónico registrado <span className="df-recuperar-required">*</span>
              </label>
              <input
                id="recuperar-email"
                type="email"
                className="df-recuperar-input"
                placeholder="ejemplo@empresa.com"
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                required
                autoComplete="email"
              />
            </div>

            {/* Caja de Captcha */}
            <div className="df-recuperar-captcha-card">
              <div className="df-recuperar-captcha-top">
                <span className="df-recuperar-captcha-label">Código de seguridad</span>
                <button
                  type="button"
                  className="df-recuperar-btn-refresh-captcha"
                  onClick={handleNuevoCaptcha}
                  title="Generar nuevo código"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="23 4 23 10 17 10"></polyline>
                    <polyline points="1 20 1 14 7 14"></polyline>
                    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                  </svg>
                  Nuevo código
                </button>
              </div>

              <div className="df-recuperar-captcha-display">
                {captcha}
              </div>

              <input
                type="text"
                className="df-recuperar-input df-recuperar-captcha-input"
                placeholder="Escribe el código mostrado arriba"
                value={humano}
                onChange={(e) => setHumano(e.target.value)}
                required
              />
            </div>
          </div>

          {/* Pie de Acciones */}
          <div className="df-recuperar-modal-footer">
            <button
              type="button"
              className="df-recuperar-btn-cancel"
              onClick={onClose}
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="df-recuperar-btn-submit"
              disabled={loading}
            >
              {loading ? (
                <>
                  <svg className="df-recuperar-spinner" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                    <circle cx="12" cy="12" r="10" strokeDasharray="32" strokeDashoffset="16"></circle>
                  </svg>
                  Enviando...
                </>
              ) : (
                'Enviar solicitud'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalRecuperarPassword;
